// removed by extract-text-webpack-plugin
module.exports = {"downloadFileName":"export-result__downloadFileName-3iOz-","downloadFileLink":"export-result__downloadFileLink-2aSPD","downloadAllButton":"export-result__downloadAllButton-2xTQb blocks__big-2DxLx blocks__white-2DChO blocks__button-1iODk","progressBar":"export-result__progressBar-1v1AI","progressBarInner":"export-result__progressBarInner-2e1X9","progressPercentage":"export-result__progressPercentage-1Fqau","progressName":"export-result__progressName-3lIJo","deleteDocumentButton":"export-result__deleteDocumentButton-2CzC3"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/export-result/export-result.css
// module id = 760
// module chunks = 0